import React from "react";
import { TrendingUp, Minus, TrendingDown, RefreshCw } from "lucide-react";

export default function TrajectoryStrip({ data }) {
  if (!data?.available) return null;
  const segs = [
    { pct: data.improved_pct, cls: "bg-emerald-500", label: "improved", icon: TrendingUp, text: "text-emerald-700" },
    { pct: data.same_pct, cls: "bg-slate-400", label: "the same", icon: Minus, text: "text-slate-600" },
    { pct: data.worse_pct, cls: "bg-rose-500", label: "worse", icon: TrendingDown, text: "text-rose-700" },
  ];
  const lead = segs.reduce((a, b) => (b.pct > a.pct ? b : a));
  return (
    <div data-testid="trajectory-strip" className="bg-white border border-slate-200 rounded-2xl p-6 mt-6">
      <div className="flex flex-wrap items-end justify-between gap-3 mb-3">
        <div>
          <p className="font-mono text-xs uppercase tracking-widest text-emerald-600 mb-1 flex items-center gap-1.5">
            <RefreshCw size={13} /> Trajectory
          </p>
          <p className="text-slate-800">
            <b data-testid="trajectory-lead" className={`font-display text-2xl ${lead.text}`} style={{ fontWeight: 800 }}>{lead.pct}%</b>
            <span className="text-slate-600"> of reviewers who checked back in say things have {lead.label === "the same" ? "stayed the same" : lead.label === "improved" ? "improved" : "gotten worse"}.</span>
          </p>
        </div>
        <span className="text-xs text-slate-400 font-mono">{data.total} check-ins · latest {data.latest_period}</span>
      </div>
      <div className="flex h-3 rounded-full overflow-hidden bg-slate-100">
        {segs.map((s) => s.pct > 0 && <div key={s.label} className={`${s.cls} transition-all`} style={{ width: `${s.pct}%` }} />)}
      </div>
      <div className="flex flex-wrap gap-x-5 gap-y-1 mt-3 text-xs text-slate-500">
        {segs.map((s) => (
          <span key={s.label} className="flex items-center gap-1.5" data-testid={`trajectory-${s.label.replace(" ", "-")}`}>
            <s.icon size={13} className={s.text} /> {s.pct}% {s.label}
          </span>
        ))}
      </div>
    </div>
  );
}
